import { RefObject } from "react";

import { OrderReference as OrderReferenceType } from "$types/OrderReference";
import ReferenceType from "$types/ReferenceType";
import { Reception } from "$types";

import ReferenceBlock from "../ReferencingBlock";
import Header from "../Header/Header";
import OrderReferenceItem from "./OrderReferenceItem";
import { VFSOLUTIONS } from "$utils/constants";

type Props = {
  addToEditedBlocks: (item: { id: string; type: string }) => void;
  companyId: string;
  warehouse: string;
  editedBlocks: { id: string; type: string }[];
  handleOnCancelEdit: (_id: string, index: number, type: ReferenceType) => void;
  hasReferencingCategory: boolean;
  index: number;
  isFocused: boolean;
  onDelete: (index: number) => void;
  setIndexToDelete: (index: number) => void;
  onReferenceTypeChange: () => void;
  orderRefItem: OrderReferenceType;
  reception: Reception;
  scrollToRef?: RefObject<HTMLDivElement>;
  downloadOrderReference?: () => void;
  createOrderReference?: () => void;
};

function OrderReference({
  addToEditedBlocks,
  companyId,
  warehouse,
  editedBlocks,
  handleOnCancelEdit,
  hasReferencingCategory,
  index,
  isFocused,
  onDelete,
  setIndexToDelete,
  onReferenceTypeChange,
  orderRefItem,
  reception,
  scrollToRef,
  downloadOrderReference,
  createOrderReference,
}: Props) {
  const isNew = !orderRefItem.id;
  const blockId = String(orderRefItem.id || orderRefItem.suborders?.[0]?.id);

  const localIsReadOnly =
    !isNew && !editedBlocks.find((obj) => obj.id === blockId) && !isFocused;

  return (
    <div ref={isFocused ? scrollToRef : null} key={orderRefItem.id}>
      <ReferenceBlock isReadOnly={localIsReadOnly}>
        <Header
          editedBlocks={editedBlocks}
          addToEditedBlocks={addToEditedBlocks}
          allowToDelete
          allowToEdit
          blockId={String(orderRefItem.id)}
          companyId={companyId}
          hasReferencingCategory={hasReferencingCategory}
          isReadOnly={localIsReadOnly}
          nestIndex={index}
          setIndexToDelete={setIndexToDelete}
          onDelete={onDelete}
          onCancelEdit={handleOnCancelEdit}
          onReferenceTypeChange={onReferenceTypeChange}
          orders={orderRefItem.orders}
          productReference={orderRefItem.productReference}
          reception={reception}
          suborders={orderRefItem.suborders}
          value={ReferenceType.ORDER}
          downloadOrderReference={downloadOrderReference}
          createOrderReference={createOrderReference}
          showLinks={
            reception?.receptionReferences?.length > 0 &&
            warehouse?.indexOf(VFSOLUTIONS) !== -1
          }
        />
        <OrderReferenceItem
          companyId={reception.company}
          isReadOnly={localIsReadOnly}
          nestIndex={index}
        />
      </ReferenceBlock>
    </div>
  );
}

export default OrderReference;
